export const LONGEVITY_LOGIN_REQUEST = "LONGEVITY_LOGIN_REQUEST";
export const LONGEVITY_LOGIN_SUCCESS = "LONGEVITY_LOGIN_SUCCESS";
export const LONGEVITY_LOGIN_FAILURE = "LONGEVITY_LOGIN_FAILURE";
